export default "__VITE_ASSET__Bo0ZAL2K__"